import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
  machineData?: any;
  autoCompleteMachineValue?: any;
  setAutoCompleteMachineValue?: any;
}

const TController = ({
  moduleData,
  tabValue,
  isView,
  machineData,
  autoCompleteMachineValue,
  setAutoCompleteMachineValue,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            tabValue,
            isView,
            machineData,
            autoCompleteMachineValue,
            setAutoCompleteMachineValue,
          }}
        />
        <TBody {...{ moduleData, tabValue, isView }} />
        <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
